var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-block-tmp",class:[_vm.sizeClass, _vm.layoutClass, { 'small-card-type': _vm.smallCardType }, _vm.typeClass]},[_c('div',{staticClass:"base-block-tmp__inner-wrapper",class:{
      'row-noGutter': !_vm.isLayout.mediaTop,
      'row-column-noGutter': _vm.isLayout.mediaTop,
      'saved-collection-link-card': _vm.isLinkCard,
    },on:{"click":_vm.simulateClickOnLink}},[_c('div',{class:{
        'row-noGutter col-12': _vm.isLayout.mediaRightSmall,
        'col-last row-noGutter': _vm.isLayout.mediaTop,
        'col-6': _vm.isLayout.mediaLeft,
        'col-7': _vm.isLayout.mediaRightSecondary,
        'row-column-noGutter': _vm.isLayout.mediaLeft || _vm.isLayout.mediaRightSecondary,
      }},[_c('div',{staticClass:"row-noGutter",class:{
          col: _vm.isLayout.mediaLeft || _vm.isLayout.mediaRightSecondary,
          'col-12': _vm.isLayout.mediaTop || _vm.isLayout.mediaRightSmall,
        }},[_c('div',{staticClass:"base-block-tmp__content-slot row-noGutter",class:{
            'col-6': _vm.isLayout.mediaRightSmall,
            'col-12': _vm.isLayout.mediaRightSecondary || _vm.isLayout.mediaLeft,
          }},[_c('div',{staticClass:"base-block-tmp__content-slot__padding"},[_vm._t("content")],2),_vm._v(" "),(_vm.isLayout.mediaRightSmall)?_vm._t("footer"):_vm._e()],2),_vm._v(" "),(_vm.isLayout.mediaRightSmall)?_c('div',{staticClass:"base-block-tmp__media col-6"},[_vm._t("media")],2):_vm._e()]),_vm._v(" "),(!_vm.isLayout.mediaRightSmall)?_vm._t("footer"):_vm._e()],2),_vm._v(" "),(!_vm.isLayout.mediaRightSmall)?_c('div',{staticClass:"base-block-tmp__media-lg",class:{
        col: _vm.isLayout.mediaTop,
        'col-5': _vm.isLayout.mediaRightSecondary,
        'col-6-first': _vm.isLayout.mediaLeft,
      }},[_vm._t("media")],2):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }